export const getSingleStatFetching = (state) => state?.stats?.singleFetching;

export const getStatData = (state) => state.stats;
